<template>
  <div>
    <div class="header-section">
      <div class="content-section">
        <h3 class="section-title">
          {{ $t("shortCodes") }}
        </h3>

        <div class="content">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <!-- Login Form Shortcode -->
            <div class="relative">
              <h4 class="text-sm text-[#4D4D4D] mb-2">{{ $t("loginShortCode") }}</h4>
          
              <div class="input-main relative">
                [smsir_login]
                <button class="absolute top-1 left-1 py-2 px-6 bg-[#F2F2F2] rounded-full text-[#0D0D0D] flex items-center gap-2" @click="copyToClipboard('[smsir_login]')">
                  <i class="icon-smsir-copy text-[18px]"></i>
                  {{ $t("common.copy") }}
                </button>
              </div>
            
            </div>

            <div class=" relative">
              <h4 class="text-sm text-[#4D4D4D] mb-2">{{ $t("loginModalShortCode") }}</h4>
           
              <div class="input-main relative">
                [smsir_login_modal]
                <button class="absolute top-1 left-1 py-2 px-6 bg-[#F2F2F2] rounded-full text-[#0D0D0D] flex items-center gap-2" @click="copyToClipboard('[smsir_login_modal]')">
                  <i class="icon-smsir-copy text-[18px]"></i>
                  {{ $t("common.copy") }}
                </button>
              </div>
            
            </div>

            <div class=" relative">
              <h4 class="text-sm text-[#4D4D4D] mb-2">{{ $t("newsletterShortCode") }}</h4>
           
              <div class="input-main relative">
                [smsir_newsletter]
                <button class="absolute top-1 left-1 py-2 px-6 bg-[#F2F2F2] rounded-full text-[#0D0D0D] flex items-center gap-2" @click="copyToClipboard('[smsir_newsletter]')">
                  <i class="icon-smsir-copy text-[18px]"></i>
                  {{ $t("common.copy") }}
                </button>
              </div>
            
            </div>
          </div>

         
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';

export default {
  props: {
    settings: {
      type: Object,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    copyToClipboard(text) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      
      // Make the textarea out of viewport
      textarea.style.position = 'fixed';
      textarea.style.left = '-999999px';
      textarea.style.top = '-999999px';
      
      // Append the textarea to the document
      document.body.appendChild(textarea);
      
      // Select the text in the textarea
      textarea.focus();
      textarea.select();
      
      // Execute the copy command
      let successful = false;
      try {
        successful = document.execCommand('copy');
      } catch (err) {
        console.error('Unable to copy to clipboard', err);
      }
      
      // Remove the temporary textarea
      document.body.removeChild(textarea);
      
      // Show a success message using SweetAlert2
      if (successful) {
        Swal.fire({
          text: this.$t('copiedToClipboard'),
          icon: 'success',
          toast: true,
          position: 'top-start',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
          customClass: {
            popup: 'smsir-swal'
          }
        });
      } else {
        Swal.fire({
          text: this.$t('failedToCopy'),
          icon: 'error',
          toast: true,
          position: 'top-start',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
          customClass: {
            popup: 'smsir-swal'
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.section-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
}

.smsir-swal {
  top: 50px !important;
  background-color: #fff !important;
  box-shadow: 0 0 1px rgba(0, 0, 0, .075), 0 1px 2px rgba(0, 0, 0, .075), 1px 2px 4px rgba(0, 0, 0, .075), 1px 3px 8px rgba(0, 0, 0, .075), 2px 4px 16px rgba(0, 0, 0, .075) !important;
}

.smsir-swal .swal2-toast .swal2-success {
  border-color: #a5dc86 !important;
}
</style>